import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Form, Dropdown, InputGroup } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import { GRADE_LIST, TEACHERS_CREATE_ACTIVITY_API, TEACHERS_HELPER_CREATE_API, TEACHERS_HELPER_CREATE_QUESTIONS_API, } from "../../../api/constants";
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import AIResponseListCard from '../../../components/ai/AIResponseListCard';
import Swal from 'sweetalert2'
const typeArray = [
    {
        id: 1,
        name: "Lesson Plan"
    },
    {
        id: 2,
        name: "Test"
    },
    {
        id: 3,
        name: "Activity"
    },
    // {
    //     id: 4,
    //     name: "Quiz"
    // },
    {
        id: 5,
        name: "Home Work"
    }
]

const TeachersHelper = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { typeParam, purposeParam, gradeParam, classParam } = location.state || {};
    // console.log("Location State:", location.state);
    const [gradeList, setGradeList] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState(gradeParam ? gradeParam : '');
    const [selectedClass, setSelectedClass] = useState(classParam ? classParam : '');
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const [selectedType, setSelectedType] = useState(typeParam ? typeParam : typeArray[0].id || '');
    const [purpose, setPurpose] = useState(purposeParam ? purposeParam : typeArray[0].name || '');
    const [topic, setTopic] = useState('');
    const [testDate, setTestDate] = useState('');
    const [testDuration, setTestDuration] = useState('');
    const [isWeighted, setIsWeighted] = useState(false);
    const [totalNonWeightedQues, setTotalNonWeightedQues] = useState('');
    const [totalMCQ, setTotalMCQ] = useState('');
    const [mcqWeight, setMCQWeight] = useState('');
    const [totalSAQ, setTotalSAQ] = useState('');
    const [saqWeight, setSAQWeight] = useState('');
    const [totalLAQ, setTotalLAQ] = useState('');
    const [laqWeight, setLAQWeight] = useState('');
    const [specialInstruction, setSpecialInstruction] = useState('');
    const [lessonPlanRefreshKey, setLessonPlanRefreshKey] = useState(0);

    const handleTypeChange = (e) => {
        e.preventDefault();
        const selectedTypeeId = e.target.value;
        setSelectedType(selectedTypeeId);
        setPurpose(typeArray.find(elm => elm.id == selectedTypeeId) || '');
    };

    const handleGradeChange = (e) => {
        e.preventDefault();
        const selectedGradeId = e.target.value;
        // Use == for loose comparison or convert both to string
        const gradeObj = gradeList.find(g => String(g.grade_name.id) === String(selectedGradeId));
        setSelectedGrade(gradeObj || {});
        setSelectedClass(gradeObj?.classes?.[0] || {});
        // console.log("Selected GradeID:", selectedGradeId);
        // console.log("Selected Grade:", gradeObj);
        // console.log("Selected Class:", gradeObj?.classes?.[0] || {});
    };

    const handleClassChange = (e) => {
        e.preventDefault();
        const classId = e.target.value;
        const classObj = (selectedGrade?.classes || []).find(c => String(c.id) == String(classId));
        setSelectedClass(classObj || {});
    };

    useEffect(() => {
        getClassList()
    }, []);

    async function getClassList() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(GRADE_LIST, "POST", {
                page: 1,
                limit: 100,
            })
            if (res.data?.response?.status === 200) {
                setGradeList(res?.data?.data?.grades)
                setSelectedGrade(gradeParam ? gradeParam : res?.data?.data?.grades?.[0] || {});
                setSelectedClass(classParam ? classParam : res?.data?.data?.grades?.[0]?.classes[0] || {});
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getTeachersHelperAiApi() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_HELPER_CREATE_API, "POST", {
                purpose: purpose?.name || purpose,
                gradeId: selectedGrade?.grade_name?.id || selectedGrade?.grade_id,
                classId: selectedClass?.id || selectedClass?.class_id,
                topic: topic,
                specialInstruction: specialInstruction,
            })
            if (res.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: res?.data?.data?.message || 'Created successfully!',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(() => {
                    setLessonPlanRefreshKey(prev => prev + 1);
                    // window.location.reload(); // Reloads the page after user clicks OK
                });
                // navigate('/dashboard/app/teachers-helper-details', {
                //     state: {
                //         text: res?.data?.data?.aiSearchResult?.result || '',
                //         textId: res?.data?.data?.aiSearchResult?.ai_search_id || '',
                //         isEdit: false
                //     }
                // });
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function createQuestions() {
        setShowMoreDataLoader(true)
        let params = null;

        if (isWeighted) {
            params = {
                gradeId: selectedGrade?.grade_name?.id || selectedGrade?.grade_id,
                classId: selectedClass?.id || selectedClass?.class_id,
                purpose: (selectedType === 2 || selectedType === "2") ? (purpose?.name?.toLowerCase() || purpose?.toLowerCase()) : "homework",
                topic: topic,
                specialInstruction: specialInstruction,
                testDate: testDate,
                testDuration: testDuration,
                isWeighted: isWeighted,
                totalMcqQuestions: totalMCQ,
                mcqQuestionWeight: mcqWeight,
                totalSaqQuestions: totalSAQ,
                saqQuestionWeight: saqWeight,
                totalLaqQuestions: totalLAQ,
                laqQuestionWeight: laqWeight
            }
        } else {
            params = {
                gradeId: selectedGrade?.grade_name?.id || selectedGrade?.grade_id,
                classId: selectedClass?.id || selectedClass?.class_id,
                purpose: (selectedType === 2 || selectedType === "2") ? (purpose?.name?.toLowerCase() || purpose?.toLowerCase()) : "homework",
                topic: topic,
                specialInstruction: specialInstruction,
                testDate: testDate,
                testDuration: testDuration,
                isWeighted: isWeighted,
                totalNonWeightedQuestions: totalNonWeightedQues,
            }
        }
        try {
            const res = await apiHandler(TEACHERS_HELPER_CREATE_QUESTIONS_API, "POST", params)
            if (res.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: res?.data?.data?.message || 'Created successfully!',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(() => {
                    // window.location.reload(); // Reloads the page after user clicks OK
                });
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function createActivityApi() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_CREATE_ACTIVITY_API, "POST", {
                // aiSearchResultId: "", //data?.ai_search_id,
                gradeId: selectedGrade?.grade_name?.id || selectedGrade?.grade_id,
                classId: selectedClass?.id || selectedClass?.class_id,
                purpose: "Activity",
                topic: topic,
                specialInstruction: specialInstruction,
            })
            if (res.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: res?.data?.data?.message || 'Activity created successfully!',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(() => {
                    // window.location.reload(); // Reloads the page after user clicks OK
                });
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    return (
        <>
            <div id='content-page' className='content-page'>
                <Container>
                    <Row>
                        <Col lg={8}>
                            {
                                showMoreDataLoader ?
                                    <div className="col-sm-12 text-center">
                                        <img src={loader} alt="loader" style={{ height: "100px" }} />
                                    </div> :
                                    <Container className='relative'>
                                        <Row className="row-eq-height">
                                            <Col md="12">
                                                <Row>
                                                    <Col md="12">
                                                        <Card className="iq-border-radius-20">
                                                            <Card.Body>
                                                                <Row style={{ paddingLeft: "30px", paddingRight: "30px", marginTop: "20px" }}>
                                                                    <Col md="12" className="mb-3">
                                                                        <h3 className="card-title">Teachers Helper</h3>
                                                                        <p>Neque convallis a cras semper auctor. Libero id faucibus nisl tincidunt egetnvallis.</p>
                                                                    </Col>
                                                                </Row>
                                                                {/* {
                                                                    apiResponseText ?
                                                                        <Col md="12" style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                                                                            <h3 className="card-title">Results</h3>
                                                                            {!editMode ? (
                                                                                <>
                                                                                    <LessonPlanScreen lessonPlanText={apiResponseText} />
                                                                                    <div className="send-btn pl-3 mb-2 d-flex justify-content-end">
                                                                                        <button type="button" className="btn btn-warning me-2" onClick={handleEdit}>Edit</button>
                                                                                        <button type="button" className="btn btn-danger" onClick={handleDelete}>Delete</button>
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <textarea
                                                                                        className="form-control mb-2"
                                                                                        rows={10}
                                                                                        value={apiResponseText}
                                                                                        onChange={e => setApiResponseText(e.target.value)}
                                                                                    />
                                                                                    <div className="send-btn pl-3 mb-2 d-flex justify-content-end">
                                                                                        <button type="button" className="btn btn-success me-2" onClick={() => handleSaveEdit(apiResponseText)}>Save</button>
                                                                                        <button type="button" className="btn btn-secondary" onClick={() => setEditMode(false)}>Cancel</button>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </Col> : */}
                                                                <Form className="email-form" style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                                                                    <Form.Group className="form-group">
                                                                        <Form.Label column sm="12" htmlFor="to" className="col-form-label">What you want to create today?</Form.Label>
                                                                        <Form.Select id="validationDefault04" required value={selectedType} onChange={handleTypeChange}>
                                                                            {typeArray.map((elm, i) => (
                                                                                <option value={elm?.id}>
                                                                                    {elm?.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                    <Form.Group className="form-group">
                                                                        <Form.Label column sm="12" htmlFor="cc" className="col-form-label">For which grade?</Form.Label>
                                                                        <Form.Select
                                                                            id="validationDefault04"
                                                                            required
                                                                            value={selectedGrade?.grade_name?.id || selectedGrade?.grade_id}
                                                                            onChange={handleGradeChange}
                                                                        >
                                                                            {gradeList.map((elm, i) => (
                                                                                <option value={elm?.grade_name?.id} key={elm?.grade_name?.id}>
                                                                                    {elm?.grade_name?.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                    <Form.Group className="form-group">
                                                                        <Form.Label column sm="12" htmlFor="cc" className="col-form-label">Add the class you want to create this {selectedClass?.name} for?</Form.Label>
                                                                        <Form.Select
                                                                            id="validationDefault04"
                                                                            required
                                                                            value={selectedClass?.id || selectedClass?.class_id}
                                                                            onChange={handleClassChange}
                                                                        >
                                                                            {(selectedGrade?.classes || []).map((elm, i) => (
                                                                                <option value={elm?.id || elm?.class_id} key={elm?.id || elm?.class_id}>
                                                                                    {elm?.name || elm?.class_name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                    <Form.Group className="form-group">
                                                                        <Form.Label column sm="12" htmlFor="cc" className="col-form-label">Topics you want to cover: </Form.Label>
                                                                        <Form.Control type="text" id="cc" placeholder="Enter topic here..."
                                                                            value={topic} onChange={(e) => setTopic(e.target.value)} />
                                                                    </Form.Group>
                                                                    {(selectedType == 2 || selectedType == 5) &&
                                                                        <Row>
                                                                            <Col sm={12}>
                                                                                <Form.Group className="form-group">
                                                                                    <Form.Label htmlFor="testDate" className="col-form-label">
                                                                                        {selectedType == 2 ? "Test" : "Home work"} date:
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        type="date"
                                                                                        id="testDate"
                                                                                        value={testDate}
                                                                                        min={new Date().toISOString().split('T')[0]} // Allow today and future dates
                                                                                        onChange={e => setTestDate(e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                    {
                                                                        (selectedType == 2 || selectedType == 5) &&
                                                                        <>
                                                                            <Row>
                                                                                <Col sm={6}>
                                                                                    <Form.Group className="form-group">
                                                                                        <Form.Label htmlFor="cc" className="col-form-label">{selectedType == 2 ? "Test" : "Home work"} duration:</Form.Label>
                                                                                        <InputGroup>
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                id="cc"
                                                                                                placeholder="Test duration here..."
                                                                                                value={testDuration}
                                                                                                onChange={(e) => setTestDuration(e.target.value)}
                                                                                                required
                                                                                            />
                                                                                            <InputGroup.Text>Minutes</InputGroup.Text>
                                                                                        </InputGroup>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={6}>
                                                                                    <Form.Group className="form-group">
                                                                                        <Form.Label htmlFor="trueFalse" className="col-form-label">
                                                                                            Is weighted type?
                                                                                        </Form.Label>
                                                                                        <Form.Select
                                                                                            id="trueFalse"
                                                                                            value={isWeighted ? "true" : "false"}
                                                                                            onChange={e => setIsWeighted(e.target.value === "true")}
                                                                                        >
                                                                                            <option value="false">False</option>
                                                                                            <option value="true">True</option>
                                                                                        </Form.Select>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            {isWeighted ? (
                                                                                <>
                                                                                    <Row>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc" className="col-form-label">
                                                                                                    Total MCQ questions:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc"
                                                                                                    placeholder="Total MCQ questions"
                                                                                                    value={totalMCQ}
                                                                                                    onChange={(e) => setTotalMCQ(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc2" className="col-form-label">
                                                                                                    MCQ question's weight:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc2"
                                                                                                    placeholder="MCQ question weight"
                                                                                                    value={mcqWeight}
                                                                                                    onChange={(e) => setMCQWeight(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc" className="col-form-label">
                                                                                                    Total Short questions:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc"
                                                                                                    placeholder="Total short questions"
                                                                                                    value={totalSAQ}
                                                                                                    onChange={(e) => setTotalSAQ(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc2" className="col-form-label">
                                                                                                    Short question's weight:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc2"
                                                                                                    placeholder="MCQ question weight"
                                                                                                    value={saqWeight}
                                                                                                    onChange={(e) => setSAQWeight(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc" className="col-form-label">
                                                                                                    Total Long questions:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc"
                                                                                                    placeholder="Total long questions"
                                                                                                    value={totalLAQ}
                                                                                                    onChange={(e) => setTotalLAQ(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc2" className="col-form-label">
                                                                                                    Long question's weight:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc2"
                                                                                                    placeholder="Long question weight"
                                                                                                    value={laqWeight}
                                                                                                    onChange={(e) => setLAQWeight(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </>
                                                                            ) : (
                                                                                <Form.Group className="form-group">
                                                                                    <Form.Label htmlFor="cc" className="col-form-label">
                                                                                        Total non weighted questions:
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        id="cc"
                                                                                        placeholder="Total non weighted questions..."
                                                                                        value={totalNonWeightedQues}
                                                                                        onChange={(e) => setTotalNonWeightedQues(e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            )}
                                                                        </>
                                                                    }

                                                                    <Form.Group className="form-group">
                                                                        <Form.Label htmlFor="subject" column sm="12" className="col-form-label">Do you have any special instruction?</Form.Label>
                                                                        <Form.Control as="textarea" className="textarea" rows={5} placeholder="Your special instruction here..."
                                                                            value={specialInstruction} onChange={(e) => setSpecialInstruction(e.target.value)} />
                                                                    </Form.Group>
                                                                    <div className="send-btn pl-3 mb-2 d-flex justify-content-end">
                                                                        <button type="button" className="btn btn-primary" onClick={() => {
                                                                            if (selectedType == 1) {
                                                                                getTeachersHelperAiApi()
                                                                            } else if (selectedType == 2) {
                                                                                createQuestions()
                                                                            } else if (selectedType == 3) {
                                                                                createActivityApi()
                                                                            } else if (selectedType == 5) {
                                                                                createQuestions()
                                                                            }
                                                                        }}>Create</button>
                                                                    </div>
                                                                </Form>
                                                                {/* } */}

                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container>
                            }
                        </Col>
                        <Col lg={4}>
                            <AIResponseListCard refreshKey={lessonPlanRefreshKey}/>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default TeachersHelper